// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGetShipTos } from "@conklin/App/Services/AllShipTosService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getShipTos } from "@insite/client-framework/Services/CustomersService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";

export const xRequestDataFromApi: typeof RequestDataFromApi = async props => {
    if (!props.apiParameter.billToId) {
        props.apiResult = await xGetShipTos(props.apiParameter);
        return;
    }

    props.apiResult = await getShipTos(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, xRequestDataFromApi);
